import { motion } from "framer-motion";
import { ArrowRight, Scale } from "lucide-react";
import { Link } from "react-router-dom";

const ServiceCard = ({ service, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{
        duration: 0.6,
        delay: index * 0.08,
        ease: "easeOut",
      }}
      whileHover={{
        y: -8,
      }}
      className="
        group
        relative
        flex
        h-full
        min-h-[360px]
        w-full
        flex-col
        overflow-hidden
        rounded-2xl
        border
        border-[var(--border-primary)]
        bg-[var(--card-bg-secondary)]
        transition-all
        duration-300
        hover:border-orange-500/40
        hover:shadow-[0_20px_60px_rgba(249,115,22,0.08)]
        sm:rounded-3xl
      "
    >
      {/* =====================================================
          BACKGROUND GLOW
      ====================================================== */}
      <div
        className="
          pointer-events-none
          absolute
          -right-20
          -top-20
          h-40
          w-40
          rounded-full
          bg-orange-500/10
          opacity-0
          blur-3xl
          transition-opacity
          duration-500
          group-hover:opacity-100
          sm:h-52
          sm:w-52
        "
      />

      {/* =====================================================
          BOTTOM GLOW
      ====================================================== */}
      <div
        className="
          pointer-events-none
          absolute
          -bottom-24
          -left-20
          h-44
          w-44
          rounded-full
          bg-orange-500/5
          opacity-0
          blur-3xl
          transition-opacity
          duration-500
          group-hover:opacity-100
        "
      />

      {/* =====================================================
          CARD CONTENT
      ====================================================== */}
      <div
        className="
          relative
          z-10
          flex
          h-full
          flex-col
          p-5
          sm:p-6
          md:p-7
          lg:p-8
        "
      >
        {/* =================================================
            ICON
        ================================================== */}
        <div
          className="
            mb-5
            flex
            h-12
            w-12
            shrink-0
            items-center
            justify-center
            rounded-xl
            bg-orange-500/10
            text-orange-500
            transition-all
            duration-300
            group-hover:bg-orange-500
            group-hover:text-white
            sm:mb-6
            sm:h-14
            sm:w-14
            sm:rounded-2xl
            md:h-16
            md:w-16
          "
        >
          <Scale
            size={24}
            strokeWidth={1.8}
            className="
              transition-transform
              duration-300
              group-hover:scale-110
              sm:h-7
              sm:w-7
              md:h-[30px]
              md:w-[30px]
            "
          />
        </div>

        {/* =================================================
            TITLE
        ================================================== */}
        <h3
          className="
            text-xl
            font-bold
            leading-tight
            text-[var(--text-primary)]
            transition-colors
            duration-300
            group-hover:text-orange-500
            sm:text-2xl
          "
        >
          {service?.hero?.title}
        </h3>

        {/* =================================================
            DESCRIPTION
        ================================================== */}
        <p
          className="
            mt-4
            line-clamp-4
            text-sm
            leading-6
            text-[var(--text-muted)]
            sm:mt-5
            sm:text-base
            sm:leading-7
            md:leading-8
          "
        >
          {service?.hero?.subtitle}
        </p>

        {/* =================================================
            BUTTON
        ================================================== */}
        <div className="mt-auto pt-3 sm:pt-4 md:pt-6">
          <Link
            to={`/legal-services/${service.slug}`}
            className="
              group/link
              inline-flex
              max-w-full
              items-center
              gap-2
              text-sm
              font-semibold
              text-orange-500
              transition-all
              duration-300
              sm:gap-3
              sm:text-base
            "
          >
            <span className="truncate">Explore Service</span>

            <ArrowRight
              size={17}
              className="
                shrink-0
                transition-transform
                duration-300
                group-hover/link:translate-x-1
                sm:h-[18px]
                sm:w-[18px]
              "
            />
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default ServiceCard;